import { useStaticIntl } from '@tribeplatform/react-components/i18n'
import { useBlock } from '@tribeplatform/react-slate-kit/hooks'
import type { BC } from '@tribeplatform/react-slate-kit/types'

import { MultiViewBlock } from '../Views/components/MultiViewBlock'
import { NetworkMemberList } from './components/NetworkMemberList'
import { SpaceMemberList } from './components/SpaceMemberList'
import { genericViewFactory, staticFieldsFactory } from './config'
import type { MembersBlockProps } from './types'

export const MembersBlock: BC<MembersBlockProps> = ({
  title,
  description,
  views,
  linkUrl,
  linkText,
}) => {
  const staticFields = useStaticIntl(staticFieldsFactory)
  const genericView = useStaticIntl(genericViewFactory)
  const {
    extraContext: { activeViewIndex, activeFieldId },
  } = useBlock<
    MembersBlockProps,
    { activeViewIndex?: number; activeFieldId?: string }
  >()

  return (
    <MultiViewBlock
      activeViewIndex={activeViewIndex}
      title={title}
      description={description}
      views={views}
      linkUrl={linkUrl}
      linkText={linkText}
    >
      {({ view }) => (
        <>
          {view && view.spaceId && (
            <SpaceMemberList view={view} activeFieldId={activeFieldId} />
          )}
          {view && !view.spaceId && (
            <NetworkMemberList view={view} activeFieldId={activeFieldId} />
          )}
          {!view && (
            <NetworkMemberList
              activeFieldId={activeFieldId}
              view={{
                ...genericView,
                fields: staticFields,
              }}
            />
          )}
        </>
      )}
    </MultiViewBlock>
  )
}
